<template>
  <v-btn icon flat small @click="goPresentacionUpdate">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
      <span>Ver actualización</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goPresentacionUpdate () {
      this.$router.push({ name: 'actualizacion', params: { id: this.item.pk } })
    }
  }
}
</script>
